import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyCKDq9KTfhBSqW75Gx2moauN9kOj0T2IW0",
  authDomain: "challenge-f4d7d.firebaseapp.com",
  databaseURL: "https://challenge-f4d7d.firebaseio.com",
  projectId: "challenge-f4d7d",
  storageBucket: "challenge-f4d7d.appspot.com",
  messagingSenderId: "772440400269",
  appId: "1:772440400269:web:1d4b6c372be30d9428ddc4",
  measurementId: "G-G86H3TX6WD",
};


// Initialize the app with the firebaseConfig
// Intialize the database (firestore => real-time database in firebase)
// Gives us a variable used to handle all the signing-in

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();

// Export these two thing, the database and the authetication, and use this outside of the file
export { db, auth };
